module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-popover', {
    ref: "popover5",
    attrs: {
      "placement": "bottom",
      "width": "160",
      "trigger": "click"
    },
    model: {
      value: (_vm.visible2),
      callback: function($$v) {
        _vm.visible2 = $$v
      },
      expression: "visible2"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_vm._v("确定退出登录吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    staticClass: "showBtn",
    attrs: {
      "size": "mini",
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.visible2 = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "showBtn",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.loginout()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('router-link', {
    staticClass: "fb-touch",
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_c('div', {
    staticClass: "na-left"
  }, [_c('img', {
    staticStyle: {
      "height": "40px",
      "margin-left": "-65px"
    },
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "na-right"
  }, [(_vm.is_navbar == true) ? _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/user_logo.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.is_navbar == false) ? _c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    staticClass: "nav-user",
    attrs: {
      "src": require("../../assets/user_logo.png")
    }
  })]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover5",
      arg: "popover5"
    }],
    attrs: {
      "index": "1-2"
    }
  }, [_vm._v("退出登录")])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "pwdForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.pwdForm,
      "rules": _vm.pwdrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.pwdForm.username),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "username", $$v)
      },
      expression: "pwdForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "oldpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码"
    },
    model: {
      value: (_vm.pwdForm.oldpassword),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "oldpassword", $$v)
      },
      expression: "pwdForm.oldpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.pwdForm.newpassword),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newpassword", $$v)
      },
      expression: "pwdForm.newpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newpasswordr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.pwdForm.newpasswordr),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newpasswordr", $$v)
      },
      expression: "pwdForm.newpasswordr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "showBtn",
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "showBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('pwdForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bc59a8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 1082
// module chunks = 2